import { type AtomEffect, atom } from "recoil";
export const localStorageEffect: <T>(
	key:
		| "show_info_bar"
		| "ndr"
		| "ndrcc"
		| "useNdrcc"
		| "ndrFontMultiplier"
		| "readingRulerMode"
		| "readingTintMode"
		| "readingRulerColor"
		| "readingRulerOpacity",
) => AtomEffect<T> =
	(key) =>
	({ setSelf, onSet }) => {
		const savedValue = localStorage.getItem(key);
		if (savedValue != null) {
			setSelf(JSON.parse(savedValue));
		}

		onSet((newValue, _, isReset) => {
			isReset
				? localStorage.removeItem(key)
				: localStorage.setItem(key, JSON.stringify(newValue));
		});
	};

export type NDRCC = { text: string; background: string };

export const ZoomFactor = atom({
	key: "zoomFactor",
	default: 1,
});

export const NeuroDivergentColorChoice = atom<NDRCC>({
	key: "VS_ NeuroDivergentColorChoice",
	default: {
		text: "#a97878",
		background: "#EDEB73",
	},
	effects: [localStorageEffect("ndrcc")],
});

export const NeuroDivergentFontMultiplier = atom<number>({
	key: "VS_NeuroDivergentFontMultiplier",
	default: 1,
	effects: [localStorageEffect("ndrFontMultiplier")],
});

export const UseNDRColors = atom<boolean>({
	key: "VS_UseNDRColors",
	default: false,
	effects: [localStorageEffect("useNdrcc")],
});

export const MarkdownNDRToggleState = atom<boolean>({
	key: "MarkdownNDRToggleState",
	default: false,
});

export const NeueroDivergentReader = atom<boolean>({
	key: "VS_NeueroDivergentReader",
	default: false,
	effects: [localStorageEffect("ndr")],
});

export const PresetColorChoices = atom<{ name: string; value: NDRCC }[]>({
	key: "VS_PresetColorChoices",
	default: [
		{ name: "Catherine's", value: { text: "#a97878", background: "#EDEB73" } },
		{ name: "Matherine", value: { text: "#ffffff", background: "#78bcf6" } },
		{ name: "Deep Seek A", value: { text: "#3D3D3D", background: "#FFFFE0" } },
		{ name: "Deep Seek B", value: { text: "#000080", background: "#FAF8ED" } },
	],
});

export const ReadingRulerMode = atom<boolean>({
	key: "VS_ReadingRulerMode",
	default: false,
	effects: [localStorageEffect("readingRulerMode")],
});

export const ReadingTintMode = atom<boolean>({
	key: "VS_ReadingTintMode",
	default: false,
	effects: [localStorageEffect("readingTintMode")],
});

export const ReadingRulerActiveAtomId = atom<number>({
	key: "VS_ReadingRulerActiveAtomId",
	default: 0,
});

export const ReadingRulerColor = atom<string>({
	key: "VS_ReadingRulerColor",
	default: "#000000",
	effects: [localStorageEffect("readingRulerColor")],
});

export const ReadingRulerOpacity = atom<number>({
	key: "VS_ReadingRulerOpacity",
	default: 0.85,
	effects: [localStorageEffect("readingRulerOpacity")],
});
